import { useTranslation } from 'react-i18next';

import './PasswordStrength.css';

export type PasswordStrengthProps = {
  value: string;
};

// Visual-only indicator. The Zod schema (auth-schemas.ts) is the
// source of truth for actual password validation — front-shell does
// not change validation behaviour, only surfaces feedback.
export function PasswordStrength({ value }: PasswordStrengthProps) {
  const { t } = useTranslation(['auth']);

  if (!value) return null;

  const rules = [
    { key: 'minLength', ok: value.length >= 8 },
    { key: 'uppercase', ok: /[A-Z]/.test(value) },
    { key: 'digit', ok: /\d/.test(value) },
  ];

  return (
    <ul className="password-strength" aria-live="polite">
      {rules.map((rule) => (
        <li
          key={rule.key}
          className={`password-strength__rule password-strength__rule--${rule.ok ? 'ok' : 'ko'}`}
        >
          <span className="password-strength__bullet" aria-hidden="true">
            {rule.ok && <span className="password-strength__check">✓</span>}
          </span>
          <span>{t(`auth:passwordStrength.${rule.key}`)}</span>
        </li>
      ))}
    </ul>
  );
}
